// Note du client sur un RDV (demande client 27/10 : « on pouvait laisser une note au SDR, on ne peut plus »).
// Champ dédié appointments.client_note — distinct de `notes` (note interne SDR/CSM, masquée au client).
// Mêmes règles que la RPC set_client_note : trim, vide → effacement, 2 000 caractères max.

export const CLIENT_NOTE_MAX = 2000;

/** Normalise la note avant envoi. Vide → null (efface). Lève si trop longue. */
export function normalizeClientNote(raw: string | null | undefined): string | null {
  const note = (raw ?? '').trim();
  if (!note) return null;
  if (note.length > CLIENT_NOTE_MAX) {
    throw new Error(`Note trop longue (${note.length} / ${CLIENT_NOTE_MAX} caractères)`);
  }
  return note;
}
